var _g, _rect, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup12212(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 885,
    height: 183,
    viewBox: "0 0 885 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_43_48579)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 6,
    width: 851,
    height: 123,
    rx: 10.5743,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.6782,
    y: 4.67821,
    width: 853.644,
    height: 125.644,
    rx: 11.8961,
    stroke: "#EBEBEB",
    strokeWidth: 2.64359
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_43_48579",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 6,
    width: 851,
    height: 123
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 6,
    width: 851,
    height: 123,
    rx: 10.5743,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_43_48579)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_43_48579)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.515,
    cy: 118.297,
    rx: 127.515,
    ry: 118.297,
    transform: "matrix(-1 0 0 1 978.254 -13.9722)",
    fill: "#FE8616"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_43_48579)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.8162,
    cy: 68.3664,
    rx: 76.8162,
    ry: 68.3664,
    transform: "matrix(-1 0 0 1 761.632 61.3076)",
    fill: "#F9D411"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M826.99 56.4784C826.99 59.9716 827.411 62.5614 828.254 64.2477H796.274C795.551 61.3568 795.19 57.6227 795.19 53.0455C795.19 38.4705 800.068 26.8467 809.825 18.174C819.702 9.38081 833.795 4.98423 852.104 4.98423C881.375 4.98423 896.01 16.7887 896.01 40.3978C896.01 48.8296 893.962 56.7193 889.867 64.067C885.771 71.2943 880.772 77.2568 874.87 81.9545C868.968 86.5318 863.066 90.567 857.163 94.0602C851.261 97.4329 846.142 100.324 841.806 102.733C837.469 105.021 835.12 106.768 834.759 107.973V108.153H883.001L877.942 136.34H783.445L785.794 122.969C787.119 115.381 790.01 108.635 794.467 102.733C798.924 96.7101 803.983 92.0124 809.644 88.6397C815.306 85.267 821.268 81.9545 827.532 78.7022C833.916 75.3295 839.698 72.3784 844.877 69.8488C850.057 67.1989 854.333 63.8261 857.706 59.7307C861.199 55.6352 862.945 51.058 862.945 45.9989C862.945 37.3262 858.067 32.9898 848.31 32.9898C841.565 32.9898 836.325 35.158 832.591 39.4944C828.857 43.7103 826.99 49.3716 826.99 56.4784Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_43_48579",
    x: 0.529495,
    y: 0.283766,
    width: 883.941,
    height: 182.059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.53632
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.30449
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_43_48579"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.21795
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.60897
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_43_48579",
    result: "effect2_dropShadow_43_48579"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19.9722
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.1453
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_43_48579",
    result: "effect3_dropShadow_43_48579"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 36.8718
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.91346
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_43_48579",
    result: "effect4_dropShadow_43_48579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_43_48579",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_43_48579",
    x: 538.865,
    y: -198.331,
    width: 623.748,
    height: 605.312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92.1795,
    result: "effect1_foregroundBlur_43_48579"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_43_48579",
    x: 423.641,
    y: -123.051,
    width: 522.35,
    height: 505.451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92.1795,
    result: "effect1_foregroundBlur_43_48579"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup12212);
export default __webpack_public_path__ + "static/media/Group 1221 (2).fa75f2cb68f4f7784b8d67ef72e9900b.svg";
export { ForwardRef as ReactComponent };